import { FadeUp } from "@/components/Reveal";

const LegalLayout = ({ title, children, testid }) => (
  <main data-testid={testid} className="bg-ivoire pt-[72px] min-h-screen">
    <div className="max-w-3xl mx-auto px-4 sm:px-8 py-16 lg:py-24">
      <FadeUp>
        <h1 className="font-display font-medium text-petrol text-3xl sm:text-4xl lg:text-5xl tracking-tight mb-12">
          {title}
        </h1>
      </FadeUp>
      <div className="space-y-10 text-sm sm:text-base text-mute leading-relaxed [&_h2]:font-display [&_h2]:text-petrol [&_h2]:text-2xl [&_h2]:font-medium [&_h2]:mb-3 [&_strong]:text-encre">
        {children}
      </div>
    </div>
  </main>
);

export default function PolitiqueConfidentialite() {
  return (
    <LegalLayout title="Politique de confidentialité" testid="politique-confidentialite-page">
      <section>
        <h2>Responsable de traitement</h2>
        <p>
          <strong>EQUORIS SAS</strong> — 2 rue de la Levée, 49400 Saumur — SIREN 101 316 719 —
          RCS Angers. Contact : contact@equoris.fr.
        </p>
      </section>
      <section>
        <h2>Demandes commerciales (formulaire « Parlons de votre chantier »)</h2>
        <p>
          Les informations transmises (identité, société, coordonnées, localisation du
          chantier, description du besoin) sont utilisées exclusivement pour qualifier votre
          demande, vous recontacter et préparer une réponse commerciale, y compris
          l'organisation éventuelle d'un déplacement sur site.
        </p>
        <p>
          <strong>Destinataires :</strong> les équipes commerciales d'EQUORIS.{" "}
          <strong>Durée de conservation :</strong> 3 ans à compter du dernier contact, sauf
          relation commerciale en cours.
        </p>
      </section>
      <section>
        <h2>Candidatures (page Recrutement)</h2>
        <p>
          Les informations recueillies (identité, coordonnées, parcours, lien professionnel)
          ont pour seule finalité l'étude de votre candidature. Elles sont destinées
          exclusivement aux personnes chargées du recrutement chez EQUORIS.
        </p>
        <p>
          <strong>Durée de conservation :</strong> le temps du processus de recrutement. Si
          votre candidature n'est pas retenue, elle n'est conservée dans un vivier de talents
          qu'avec votre accord explicite, pour une durée maximale de 2 ans à compter du
          dernier contact, puis supprimée.
        </p>
        <p>
          Seules les informations en lien direct et nécessaire avec le poste et l'évaluation
          des aptitudes professionnelles sont demandées.
        </p>
      </section>
      <section>
        <h2>Vos droits</h2>
        <p>
          Vous disposez de droits d'accès, de rectification, d'effacement, de limitation,
          d'opposition et de portabilité sur les données vous concernant. Pour les exercer :
          contact@equoris.fr. Vous pouvez également introduire une réclamation auprès de la
          CNIL (cnil.fr).
        </p>
      </section>
      <section>
        <h2>Sécurité et sous-traitants</h2>
        <p>
          Les données sont hébergées de manière sécurisée. EQUORIS s'appuie sur des
          prestataires techniques (hébergement Cloudflare, service d'envoi d'emails) soumis à
          des obligations de confidentialité. Aucune donnée n'est cédée à des tiers à des fins
          commerciales.
        </p>
      </section>
      <section>
        <h2>Cookies</h2>
        <p>
          Le site n'utilise pas de cookies publicitaires ni de mesure d'audience
          nominative.
        </p>
      </section>
    </LegalLayout>
  );
}
